import configBetaJkos from './config-beta-jkos.js'
import configProdJkos from './config-prod-jkos.js'
import configProdPreBeta from './config-prod-prebeta.js'
import configProd from './config-prod.js'
import configBeta from './config-beta.js'
import configBetaDev from './config-beta-dev.js'
import configDefault from './config.js'

let config
const brand = process.env.brand || null
const mode = process.env.mode || null

switch (brand) {
  case 'jkos':
    switch (mode) {
      case 'beta':
        config = configBetaJkos
        break
      case 'prod':
        config = configProdJkos
        break
      default:
        config = configProdJkos
        break
    }
    break
  case 'nidin':
    switch (mode) {
      case 'beta-dev':
      case 'dev':
        config = configBetaDev
        break
      case 'beta':
        config = configBeta
        break
      case 'prebeta':
        config = configProdPreBeta
        break
      default:
        config = configProd
        break
    }
    break
  default:
    config = configDefault
    break
}

export default config



// WEBPACK FOOTER //
// ./src/assets/js/handle-config.js